//@flow

import styled from 'styled-components';

import {Rating} from '.';
import {aquamarineBlue, shark} from "../variables";

export default styled(Rating)`
    background-color: ${aquamarineBlue}
    
    &:before {
        content: "";
        width: 7px;
        height: 7px;
        border-top: 1px solid ${shark};
        border-left: 1px solid ${shark};
        position: absolute;
        top: 8px;
        left: 7px;
        transform: rotate(45deg);
        border-radius: 1px;
    }
`;
